module.exports = __webpack_public_path__ + "static/media/upload.bb60b49a.svg";